import React from "react";
import * as theme from "../theme";
import WhiteTextField from "./TextFieldCustomized";
import PerfectScrollbar from "react-perfect-scrollbar";
import { useDispatch, useSelector } from "react-redux";
import { getLanguagePreference, getBrokerInformation } from "../store/broker";
import { changeLanguageCode } from "../store/components";
import { useState, useEffect } from "react";
import {
  getOperationsList,
  getOperationsSelected,
  loadOperations,
  operationSelected,
} from "../store/operations";
import { getInsurersList } from "../store/insurers";
import { getProductsSelected, getProductList } from "../store/products";

const WelcomeBackRightPane = () => {
  const insurerList = useSelector(getInsurersList);
  const currentOperations = useSelector(getOperationsSelected);
  const productList = useSelector(getProductList);
  const product = productList?.find((x) => x.selected);

  let [selectedVerticalId, setSelectedVerticalId] = useState(null);
  const insurers = selectedVerticalId
    ? insurerList.filter((x) => x.verticalids.includes(selectedVerticalId))
    : [];
  useEffect(() => {
    if (product && currentOperations?.length) {
      const newVerticalId =
        product.verticalid === 1
          ? currentOperations[0]?.verticalid
          : product?.verticalid;
      if (newVerticalId && selectedVerticalId !== newVerticalId) {
        setSelectedVerticalId(newVerticalId);
      }
    } else {
      setSelectedVerticalId(null);
    }
  }, [product, currentOperations, productList]);

  return (
    <PerfectScrollbar>
      <AskQuoteyPane
        displayRescue={selectedVerticalId == null}
        insurers={insurers}
      />
    </PerfectScrollbar>
  );
};

const QuoteyRescueQA = [
  {
    id: 1,
    que: "Did you know?",
    ans: "Quotey was created by brokers to bring business insurance into the digital age.  Why should personal lines have all the fun?  Our vision is to help you get multiple insurer quotes for your client in real-time, compare coverages and share with your client to help you seal the deal.",
  },
  {
    id: 2,
    que: "Another helpful tip",
    ans: "You can save an application at any time or skip most questions and come back to them when your client has the right information.  Quotey will go as fast, or as slow, as you want – but either way, will help you organize the process from end-to-end.",
  },
  {
    id: 3,
    que: "Don't forget",
    ans: "Once you’ve completed an application with your client, even if you don’t get immediate quotes and comparisons, you can still use Quotey to send to market and track insurer responses.",
  },
  {
    id: 4,
    que: "In case you were wondering",
    ans: "We’re bringing on new insurers and products on a regular basis.  We’re also continually adding new questions to make Quotey’s applications as intuitive and efficient as possible",
  },
];

const QuoteyRescueQAFr = [
  {
    id: 1,
    que: "Saviez-vous ?",
    ans: "Quotey a été créé par des courtiers pour moderniser l'assurance des entreprises. Pourquoi les particuliers devraient-ils être les seuls à en profiter ? Notre vision est de vous aider à obtenir des devis de plusieurs assureurs en temps réel pour votre client, à comparer les garanties et à les partager avec votre client pour vous aider à conclure l'affaire.",
  },
  {
    id: 2,
    que: "Un autre conseil utile",
    ans: "Vous pouvez sauvegarder une demande à tout moment ou passer la plupart des questions et y revenir lorsque votre client aura les bonnes informations. Quotey ira aussi vite ou aussi lentement que vous le souhaitez, mais dans tous les cas, vous aidera à organiser le processus du début jusqu'à la fin.",
  },
  {
    id: 3,
    que: "N'oubliez pas",
    ans: "Une fois que vous avez terminé une demande avec votre client, même si vous n'obtenez pas de devis et de comparaisons immédiats, vous pouvez toujours utiliser Quotey pour l'envoyer sur le marché et suivre les réponses des assureurs.",
  },
  {
    id: 4,
    que: "Pour ceux qui se posent la question",
    ans: "Nous ajoutons régulièrement de nouveaux assureurs et produits. Nous ajoutons également continuellement de nouvelles questions pour rendre les demandes de Quotey aussi intuitives et efficaces que possible.",
  },
];

const AskQuoteyPane = ({ displayRescue, insurers }) => {
  const dispatch = useDispatch();
  const brokerLangugePref = useSelector(getLanguagePreference);
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;
  dispatch(changeLanguageCode(languagepreference));

  console.log("brokerLangugePref", languagepreference);
  return (
    <div
      style={{
        margin: "3.5rem",
        marginTop: "7rem",
      }}
    >
      {/* <WhiteTextField></WhiteTextField> */}

      {displayRescue && (
        <>
          <div
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 16,
              color: theme.COLORS.primary_navyblue,
              letterSpacing: 1,
            }}
          >
            {languagepreference === "fr"
              ? "Quotey à la rescousse !"
              : "Quotey to the Rescue!"}
          </div>
          <br></br>
          <QuoteyRescue></QuoteyRescue>
        </>
      )}
      {!displayRescue && (
        <>
          <div
            style={{
              fontFamily: "GibsonSemiBd",
              fontSize: 16,
              color: theme.COLORS.primary_navyblue,
              letterSpacing: 1,
            }}
          >
            {languagepreference === "fr"?"Assureurs Connecté":"Connected Insurer"}
          </div>
          <p>
          {languagepreference === "fr"?
          `Les assureurs suivants seront connectés pour examiner cette soumission une fois complétée. Veuillez noter que chacun 
          d’eux possède des critères de souscription détaillés qui peuvent entraîner des références ou des refus.`:
          ` The following insurers will be connected to review this application when completed. 
          Please note that each will have detailed underwriting criteria that may lead to referrals or declines.`}
           
          </p>
          <div
            style={{
              display: displayRescue ? "none" : "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "20px",
              justifyItems: "center",
              paddingTop: "15px",
            }}
          >
            {insurers.map((insurer) => (
              <img
                key={insurer.code}
                title={insurer.name}
                src={insurer.s3image?.Location}
                style={{ width: "70%" }}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

const QuoteyRescue = () => {
  const brokerage = useSelector(getBrokerInformation);
  const languagepreference = brokerage.information.languagepreference;

  const tempQuoteyRescueQA =
    languagepreference === "fr" ? QuoteyRescueQAFr : QuoteyRescueQA;
  return tempQuoteyRescueQA.map((queans) => {
    return (
      <div key={queans.id}>
        <div
          style={{
            fontFamily: "GibsonRegular",
            color: theme.COLORS.secondary_orange,
            fontWeight: "bold",
            fontSize: "max(12px,0.9vw)",
            letterSpacing: 1,
          }}
        >
          {queans.que}
        </div>
        <div
          style={{
            fontFamily: "GibsonRegular",
            fontSize: "max(12px, 0.7vw)",
            color: "gray",
            marginTop: 0,
            lineHeight: "2",
          }}
        >
          {queans.ans}
        </div>
        <br></br>
      </div>
    );
  });
};

export default WelcomeBackRightPane;
